module.exports = __webpack_public_path__ + "static/images/containers/Landing/images/landing-promo-bg.53464313.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/images/landing-promo-bg.jpg
// module id = 3166
// module chunks = 11